import { groupTabLines, ordersByStretch } from "@/lib/billing";
import { formatDuration, formatMoney } from "../lib/format";

function formatTime(value) {
  return new Date(value).toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}

/**
 * The bill table by table, for a game that moved: when it was on each table, how
 * long, at what rate, and what was bought there. Used on the Stop bill and in
 * History. `running` marks the last stretch as the table the game is on now.
 */
export default function TableStretches({ stretches, orders, running = false }) {
  const bought = ordersByStretch(stretches, orders);
  return (
    <div className="rounded-lg border border-zinc-700 bg-zinc-950/60 divide-y divide-zinc-800" data-testid="table-stretches">
      {stretches.map((stretch, i) => {
        const lines = groupTabLines(bought[i]);
        const itemsAmount = lines.reduce((sum, line) => sum + line.amount, 0);
        const current = running && i === stretches.length - 1;
        return (
          <div key={stretch.from} className="p-3 space-y-1" data-testid={`stretch-${i}`}>
            <div className="flex items-baseline justify-between gap-3">
              <span className="min-w-0 text-sm font-medium text-zinc-100">
                {stretch.tableName}
                {current && <span className="text-zinc-500 font-normal"> · this table</span>}
              </span>
              <span className="shrink-0 text-sm font-semibold text-zinc-100">
                ₹{formatMoney(stretch.amount + itemsAmount)}
              </span>
            </div>
            <div className="text-[11px] text-zinc-500">
              {formatTime(stretch.from)} – {current ? "now" : formatTime(stretch.to)}
              {" · "}{formatDuration(stretch.minutes)} played
            </div>
            {stretch.segments.map((seg) => (
              <div key={`${seg.rate}|${seg.label}`} className="flex items-center justify-between gap-3 text-xs">
                {/* "Normal · 3 Controllers" is still the normal rate */}
                <span className={`min-w-0 ${seg.label.startsWith("Normal") ? "text-zinc-400" : "text-amber-400"}`}>
                  {seg.label} · {formatDuration(seg.minutes)} @ ₹{formatMoney(seg.rate)}/hr
                </span>
                <span className="shrink-0 text-zinc-300">
                  ₹{formatMoney(stretch.segments.length === 1 ? stretch.amount : seg.amount)}
                </span>
              </div>
            ))}
            {lines.map((line) => (
              <div key={line.itemId} className="flex items-center justify-between gap-3 text-xs">
                <span className="min-w-0 text-zinc-400">
                  {line.name} × {line.quantity}
                  {line.players.size > 0 && <span className="text-zinc-500"> · {[...line.players].join(", ")}</span>}
                </span>
                <span className="shrink-0 text-zinc-300">₹{formatMoney(line.amount)}</span>
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
}
